// extracted by mini-css-extract-plugin
export default {"root":"Home_root__31PO7","layout-container":"Home_layout-container__JdK4d","container":"Home_container__XoXco","spinnerWrapper":"Home_spinnerWrapper__Gb+52","heroSection":"Home_heroSection__sJd+R","title":"Home_title__AL279","titleHighlight":"Home_titleHighlight__KafDt","primaryButton":"Home_primaryButton__0+g6W","avatarsSection":"Home_avatarsSection__xI1zS"};
    if(module.hot) {
      // 1763446807597
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  